import { PaymentProfile } from './payment-profile';

/** AuthorizeNet profile. */
export class AuthorizeNetProfile {
  constructor(data) {
    this.description = data.description;
    this.customerProfileId = data.customerProfileId;

    /** @type {PaymentProfile[]} */
    this.paymentProfiles = data.paymentProfiles;
  }
}
